import img1 from '../../img/app/slide1.jpg';
import img2 from '../../img/app/slide2.jpg';
import img3 from '../../img/app/slide3.jpg';
import img4 from '../../img/app/slide4.jpg';
import img5 from '../../img/app/slide5.jpg';
import img6 from '../../img/app/slide6.jpg';
import img7 from '../../img/app/slide7.jpg';
import img8 from '../../img/app/slide8.jpg';
import img9 from '../../img/app/slide9.jpg';
import img10 from '../../img/app/slide10.jpg';
import img11 from '../../img/app/slide11.jpg';
import img12 from '../../img/app/slide12.jpg';
import img13 from '../../img/app/slide13.jpg';
import img14 from '../../img/app/slide14.jpg';
import img15 from '../../img/app/slide15.jpg';
import img16 from '../../img/app/slide16.jpg';
export const DataCarousel = [
    {
        index:1,
        img:img1
    },
    {
        index:2,
        img:img2
    },
    {
        index:3,
        img:img3
    },
    {
        index:4,
        img:img4
    },
    {
        index:5,
        img:img5
    },
    {
        index:6,
        img:img6
    },
    {
        index:7,
        img:img7
    },
    {
        index:8,
        img:img8
    },
    {
        index:9,
        img:img9
    },
    {
        index:10,
        img:img10
    },
    {
        index:11,
        img:img11
    },
    {
        index:12,
        img:img12
    },
    {
        index:13,
        img:img13
    },
    {
        index:14,
        img:img14
    },
    {
        index:15,
        img:img15
    },
    {
        index:16,
        img:img16
    },

]